import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { phrApi } from '../../api/api';
import DefaultImage from '../../assets/images/profile_fill.svg';

class S3Image extends Component {
  state = {
    src: DefaultImage,
    isMounted: false
  };

  async componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.s3Key !== nextProps.s3Key && nextProps.s3Key) {
      this.setState({ src: DefaultImage });
      const url = await phrApi('post', 's3_access_url', {
        urls: [nextProps.s3Key]
      });
      // eslint-disable-next-line react/no-did-mount-set-state
      if (this.state.isMounted) {
        this.setState({
          src: url.data[0].accessUrl
        });
      }
    }
  }

  async componentDidMount() {
    this.setState({ isMounted: true });
    if (!this.props.s3Key) {
      return;
    }
    const url = await phrApi('post', 's3_access_url', {
      urls: [this.props.s3Key]
    });
    // eslint-disable-next-line react/no-did-mount-set-state
    if (this.state.isMounted) {
      this.setState({
        src: url.data[0].accessUrl
      });
    }
  }
  componentWillUnmount() {
    this.setState({ isMounted: false });
  }
  render() {
    const { src } = this.state;
    // if (!src) return null;
    return (
      <img
        src={src}
        style={this.props.style}
        alt={'snapcare'}
        className={this.props.className}
        onClick={this.props.onClick}
      />
    );
  }
}

S3Image.propTypes = {
  s3Key: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func
};
S3Image.defaultProps = {
  style: {},
  onClick: () => {}
};

export default S3Image;
